import React from 'react';
import BagelSmsConsentForm from 'features/auth/components/BagelSmsConsentForm/BagelSmsConsentForm';

function BagelSmsConsentPage() {
  return <BagelSmsConsentForm />;
}

export default BagelSmsConsentPage;
